import { AnimatePresence, motion } from "framer-motion";
import { WifiOff } from "lucide-react";
import useOnlineStatus from "../hooks/useOnlineStatus";
import usePrefersReducedMotion from "../hooks/usePrefersReducedMotion";

/**
 * Covers the realistic bulk of "offline" for this PWA: browsing the
 * already-cached app shell (see vite.config.ts's navigateFallback note) with
 * no network. A persistent top banner while offline, rather than a one-time
 * error page — pages you've already cached keep working, so a full-page
 * takeover would overstate how broken things actually are.
 */
export default function OfflineBanner() {
  const online = useOnlineStatus();
  const reducedMotion = usePrefersReducedMotion();

  return (
    <AnimatePresence>
      {!online && (
        <motion.div
          role="status"
          aria-live="polite"
          initial={reducedMotion ? false : { opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -30 }}
          transition={{ duration: reducedMotion ? 0 : 0.25 }}
          // top-8, not top-0: sits below DisclaimerBanner's always-on h-8 strip.
          className="fixed inset-x-0 top-8 z-[60] flex items-center justify-center gap-2 bg-coral-500 px-4 py-2 text-center text-xs font-semibold text-white sm:text-sm"
        >
          <WifiOff className="h-3.5 w-3.5 shrink-0" />
          You&apos;re offline — showing pages you&apos;ve already loaded.
        </motion.div>
      )}
    </AnimatePresence>
  );
}
